import React, {useCallback, useState} from "react";
export function Pagination({page, meta, updatePage}) {
  const [activeId, setActiveId] = useState(parseInt(page ?? 1));

  let totalPages = parseInt(meta['totalPages']);
  let currentPage = parseInt(meta['currentPage']);


  const filterPage = (filter) => {
    filter = parseInt(filter);
    if (0 < filter && filter <= totalPages) {
      setActiveId(filter)
      //send pagination to parent component (search.js)
      updatePage(filter);
    }
  };

  const difference = (a, b) => { return Math.abs(a - b); }

  const getPages = useCallback(() => {
    let pages = [];
    let start = activeId - 4;
    let end = activeId + 4

    if (start <= 0) {
      end = end - (start - 1);
      start = 1;
    }

    if (end > totalPages) {
      start = start + (totalPages - end);
      end = totalPages;
    }

    if (totalPages < 10) {
      end = totalPages;
      start = 1
    }

    for (let page = start; page < end + 1; page++) {
      pages.push(
        <a key={page} className={`pager ${activeId == page ? 'pager-active' : 'pager-inactive'}`}
           onClick={() => filterPage(page)} data-page={page} role="link" aria-label={`Go to page ${page}`}
           tabIndex="0"><span className="page-number">{page}</span></a>
      );
    }

    return pages;
  }, [ page, meta ]);

  return (
    <div className={`pagination wdg-mt--lg wdg-mb--md ${totalPages == 0 ? 'no-pager': ''}`} data-name="pagination" data-type="pager">
      <div className="pagination__wrap alignwide" role="navigation">
        <a className={`pager-prev ${activeId == 1 ? 'pager-disabled' : 'pager-enabled' }`}
           onClick={() => filterPage(activeId-1)} role="link" aria-label="prev" tabIndex="0">Prev</a>
        {getPages()}
        <a className={`pager-next ${activeId == totalPages ? 'pager-disabled' : 'pager-enabled'}`}
           onClick={() => filterPage(activeId+1)} role="link" aria-label="next" tabIndex="0">Next</a>
      </div>
    </div>
  );
}
